import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'scWalletNumber',
})
export class WalletNumberPipe implements PipeTransform {
  transform(walletNumber: string): string {
    return walletNumber.replace(/(\d{4})(?=\d)/g, '$1 ');
  }
}
